import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import OnboardingStepRolePreferencesUi from '../ui/screens/onboarding-step-role-preferences.ui';
import { RootStoreContext } from '../../core/root-store';
import { OnboardingData } from '../onboarding.type';

const OnboardingStepRolePreferencesContainerProps = observer(() => {
  const rootStore = useContext(RootStoreContext);
  const store = rootStore.onboardingStore;
  const { role } = store.formData;
  const stepErrors = store.shouldShowStepErrors;

  const updateField = (field: keyof OnboardingData, value: string | null) => {
    store.updateField(field, value);
  };

  return (
    <OnboardingStepRolePreferencesUi
      role={role!}
      projectRole={store.formData.target_role}
      projectStage={store.formData.project_stage}
      timeframe={store.formData.timeframe}
      compensation={store.formData.compensation}
      longDescription={store.formData.longDescription}
      projectRolesError={stepErrors.target_role}
      projectStageError={stepErrors.project_stage}
      timeframeError={stepErrors.timeframe}
      compensationError={stepErrors.compensation}
      longDescriptionError={stepErrors.longDescription}
      isSubmitting={store.isSavingStep}
      isOpenToOtherRoles={store.formData.webOnboarding?.optedIn || false}
      onUpdateField={updateField}
      onUpdateBooleanField={() => store.updateBooleanField('webOnboarding')}
    />
  );
});

export default OnboardingStepRolePreferencesContainerProps;
